import clsx from "clsx";
import Image from "next/image";

import type { TicketPromotionCoverImageInfo } from "../../(default)/ticket-reservations/form/page";

const DEFAULT_COVER_IMAGE = "/i/tentative-reservation-banner.jpg";

/**
 * 宿泊予約のページに表示されるヒーロー画像
 *
 * @param titles ヒーロー画像に表示するタイトル
 * @param coverImage ヒーロー画像を変更する場合に指定
 */
export function ReservationHero({
  titles,
  coverImage,
}: {
  titles: string[];
  coverImage?: {
    mobile: TicketPromotionCoverImageInfo;
    desktop: TicketPromotionCoverImageInfo;
  };
}) {
  const baseClassName =
    "flex w-full flex-col justify-center bg-cover bg-center bg-no-repeat md:items-center";

  return coverImage ? (
    <>
      <header className={clsx(baseClassName, "flex md:hidden")}>
        <Image
          src={coverImage?.mobile.path ?? DEFAULT_COVER_IMAGE}
          alt={coverImage?.mobile.alt ?? titles?.join(" ") ?? ""}
          className="h-auto w-full object-contain"
          width={coverImage?.mobile.width ?? 0}
          height={coverImage?.mobile.height ?? 0}
        />
      </header>
      <header className={clsx(baseClassName, "hidden md:flex")}>
        <Image
          src={coverImage?.desktop.path ?? DEFAULT_COVER_IMAGE}
          alt={coverImage?.desktop.alt ?? titles?.join(" ") ?? ""}
          className="h-auto w-full object-contain"
          width={coverImage?.desktop.width ?? 0}
          height={coverImage?.desktop.height ?? 0}
        />
      </header>
    </>
  ) : (
    <header
      className={clsx(baseClassName, "h-[240px]")}
      style={{
        backgroundImage: `url('${DEFAULT_COVER_IMAGE}')`,
      }}
    >
      <div className="mx-auto w-[315px] text-white md:w-[690px]">
        <h1 className="flex flex-col text-[16px] leading-8 font-bold">
          {titles.map((title, index) => (
            <span key={index} className="inline-block">
              {title}
            </span>
          ))}
        </h1>
      </div>
    </header>
  );
}
